import auth from "@/services/auth";
import notification from "@/services/notification";

const state = {
  errors: null,
  isLoading: false,
  authToken: auth.authToken(),
  customerDetails: auth.customerDetails(),
  customerMobile: auth.customerMobile(),
  customerEmail: auth.customerEmail(),
  customerOtp: auth.customerOtp(),
  autoLoginCreds: null
};

const getters = {
  errors: (state) => state.errors,
  isLoading: (state) => state.isLoading,
  authToken: (state) => state.authToken,
  customerDetails: (state) => state.customerDetails,
  customerMobile: (state) =>  state.customerMobile,
  customerEmail: (state) => state.customerEmail,
  customerOtp: (state) => state.customerOtp,
  autoLoginCreds: (state) => state.autoLoginCreds
};

const mutations = {
  setErrors(state, errors) {
    state.errors = errors;
  },
  setLoading(state, value) {
    state.isLoading = value;
  },
  setAuthToken(state) {
    state.authToken = auth.authToken();
  },
  setCustomerDetails(state) {
    state.customerDetails = auth.customerDetails();
  },
  setCustomerMobile(state) {
    state.customerMobile = auth.customerMobile();
  },
  setCustomerEmail(state) {
    state.customerEmail = auth.customerEmail();
  },
  setCustomerOtp(state) {
    state.customerOtp = auth.customerOtp();
  },
  setAutoLogin(state, payload) {
    state.autoLoginCreds = payload
  }
};

const actions = {
  login: async ({ commit }, payload) => {
    commit("setLoading", true);
    try {
      const { message, data_stitching } = await auth.login(payload);
      commit("setAuthToken");
      commit("setCustomerDetails");
      if (message) notification.success(message);
      if (data_stitching && data_stitching.unilever_id) return data_stitching.unilever_id;
    } catch (errors) {
      notification.warning(errors.errors.message ? errors.errors.message : "Oops, something went wrong.");
      commit("setErrors", errors.errors);
    } finally {
      commit("setLoading", false);
    }
  },
  register: async ({ commit }, payload) => {
    commit("setLoading", true);
    try {
      const { message, data_stitching } = await auth.register(payload);
      commit("setAuthToken");
      commit("setCustomerDetails");
      if (message) notification.success(message);
      if (data_stitching && data_stitching.unilever_id) return data_stitching.unilever_id;
    } catch (errors) {
      // notification.warning(errors.errors.message ? errors.errors.message : "Oops, something went wrong.");
      commit("setErrors", errors.errors);
    } finally {
      commit("setLoading", false);
    }
  },
  setPin: async ({ commit }, payload) => {
    commit("setLoading", true);
    try {
      const { message } = await auth.setPin(payload);
      if (message)
        notification.success(message);
    } catch (errors) {
      notification.warning(errors.errors.message ? errors.errors.message : "Oops, something went wrong.");
      commit("setErrors", errors.errors);
    } finally {
      commit("setLoading", false);
    }
  },
  sendOtp: async ({ commit }, payload) => {
    commit("setLoading", true);
    try {
      const { message } = await auth.sendOtp(payload);
      commit("setCustomerMobile");
      if (message)
        notification.success(message);
    } catch (errors) {
      notification.warning(errors.errors.message ? errors.errors.message : "Oops, something went wrong.");
      commit("setErrors", errors.errors);
    } finally {
      commit("setLoading", false);
    }
  },
  verifyOtp: async ({ commit }, payload) => {
    commit("setLoading", true);
    try {
      const { message } = await auth.verifyOtp(payload);
      commit("setCustomerDetails");
      commit("setAuthToken");
      commit("setCustomerOtp");
      if (message)
        notification.success(message);
    } catch (errors) {
      notification.warning(errors.errors.message ? errors.errors.message : "Oops, something went wrong.");
      commit("setErrors", errors.errors);
    } finally {
      commit("setLoading", false);
    }
  },
  resetMpin: async ({ commit, state }, pin) => {
    commit("setLoading", true);
    try {
      const { message } = await auth.resetMpin({
        pin: pin,
        mobile_number: state.customerDetails.mobile_number,
        otp: state.customerOtp
      });
      commit("setAutoLogin", {
        pin: pin,
        mobile_number: state.customerDetails.mobile_number
      });
      commit("setCustomerDetails");
      commit("setAuthToken");
      commit("setCustomerOtp");
      if (message)
        notification.success(message);
    } catch (errors) {
      notification.warning(errors.errors.message ? errors.errors.message : "Oops, something went wrong.");
      commit("setErrors", errors.errors);
    } finally {
      commit("setLoading", false);
    }
  },
  sendOtpEmail: async ({ commit }, payload) => {
    commit("setLoading", true);
    try {
      const { message } = await auth.sendOtpEmail(payload);
      commit("setCustomerEmail");
      if (message)
        notification.success(message);
    } catch (errors) {
      notification.warning(errors.errors.message ? errors.errors.message : "Oops, something went wrong.");
      commit("setErrors", errors.errors);
    } finally {
      commit("setLoading", false);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
